module.exports = __webpack_public_path__ + "assets/3-sales-manager-average-salary.a5058c70.png";